import React from "react";
// css
import "../media/css/about.css";
// img
import picture from "../media/img/picture.webp";
// body
const About = () => {
  return (
    <section id="about" className="section-about">
      <div className="layer"></div>
      <div className="container">
        <div className="content">
          <div className="section-title">
            <div className="title">
              <h2>ABOUT</h2>
              <p>mymail@gmail.com</p>
            </div>
          </div>
          <img className="picture" src={picture} alt="picture" />

          <article>
            <p>
              Hi, I’m Jason Martin, a dedicated graphic designer with over 10
              years of experience in creating impactful and visually striking
              designs. I specialize in branding, web design, and digital
              illustration, using tools like Adobe Creative Suite, Figma, and
              Sketch to bring fresh, innovative ideas to life.
            </p>
            <p>
              I’ve worked with a wide range of clients, from small startups to
              established brands, helping them develop strong visual identities
              that engage their target audiences.
            </p>
            <p>
              In addition to branding and web design, I have extensive
              experience in motion graphics, packaging design, and social media
              content creation, allowing me to offer a comprehensive range of
              services to my clients. Whether it’s creating a cohesive brand
              identity or designing an intuitive website, I’m passionate about
              delivering results that resonate.
            </p>
          </article>
        </div>
        {/* img */}
        <div className="address">
          <p>Florida, Orlando</p>
          <span>456 Sunshine Blvd, FL 32801, USA</span>
        </div>
      </div>
    </section>
  );
};

export default About;
